import React, { useContext, useEffect, useState } from "react";
import {
  useGetPendingRequests,
  useMarkUnderReview,
} from "../../../hooks/useGuidelines";
import { message, Modal, Pagination, Table } from "antd";
import Button from "../../../common/Button";
import "./style.scss";
import ViewDocuments from "../ViewDocuments";
import { GuidelinesSelectedCategoryContext } from "../../../context/guidelinesProvider";

const CreationRequest = () => {
  const [pendingRequests, setPendingRequests] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [viewDocuments, setViewDocuments] = useState(false);
  const [selected, setSelected] = useState(null);

  const {
    guide_selectedRequestId,
    guide_selectedMarkedReview,
    guide_setSelectedMarkedReview,
  } = useContext(GuidelinesSelectedCategoryContext);

  const onSuccessGetPendingRequests = (res) => {
    setPendingRequests(res?.data?.data);
    setTotalCount(res?.data?.totalCount);
  };
  const onErrorGetPendingRequests = () => {};

  const { data: getPendingRequests, refetch: refetchPendingRequests } =
    useGetPendingRequests(
      "getPendingRequests",
      pageNum,
      pageSize,
      "NewGuidelineRequestFromUser",
      onSuccessGetPendingRequests,
      onErrorGetPendingRequests
    );

  const onSuccessMarkUnderReview = (res) => {
    if (res?.status === 200) {
      message?.success("Marked under review");
      guide_setSelectedMarkedReview(res?.data?._id);
    }
  };
  const onErrorMarkUnderReview = (err) => {
    message.error(err);
  };
  const { mutate: markUnderReview } = useMarkUnderReview(
    onSuccessMarkUnderReview,
    onErrorMarkUnderReview
  );

  const handleStart = (id, clientName, marketPlaceName) => {
    guide_setSelectedMarkedReview(id);
    sessionStorage.setItem("guide_selectedMarkedReview", id);
    let payload = {
      requestId: guide_selectedMarkedReview,
    };
    window.open(
      `/?clientName=${clientName}&marketPlaceName=${marketPlaceName}&requestId=${id}`,
      "_self"
    );
    markUnderReview(payload);
  };

  useEffect(() => {
    const persistedReview = sessionStorage.getItem(
      "guide_selectedMarkedReview"
    );
    if (persistedReview) {
      const cleanPersistedReview = persistedReview.replace(/^"|"$/g, "");
      guide_setSelectedMarkedReview(cleanPersistedReview);
    }
  }, []);

  const onPageChange = (page, size) => {
    if (page !== pageNum) {
      setPageNum(page);
    } else {
      setPageSize(size);
      setPageNum(1);
    }
  };

  const getDocumentsModal = () => {
    return (
      <Modal
        title="View Documents"
        centered
        open={viewDocuments}
        footer={null}
        width="30%"
        height="auto"
        className="create_marketplace_modal_wrapper"
        onCancel={() => setViewDocuments(false)}
      >
        <ViewDocuments selected={selected} pendingRequests={pendingRequests} />
      </Modal>
    );
  };

  const columns = [
    {
      title: "Name",
      key: "userName",
      align: "center",
      dataIndex: "userName",
      render: (_, record, index) => {
        return <div>{record?.raisedBy?.userName}</div>;
      },
    },
    {
      title: "Email",
      key: "userEmail",
      align: "center",
      dataIndex: "userEmail",
      render: (_, record, index) => {
        return <div>{record?.raisedBy?.userEmail}</div>;
      },
    },

    {
      title: "Action",
      key: "action",
      align: "center",
      dataIndex: "action",
      render: (_, record) => {
        const isUnderReview = guide_selectedMarkedReview === record?._id;
        return (
          <div className="action_btns">
            <Button
              text={isUnderReview ? "Under Review" : "Start"}
              width="100px"
              height="40px"
              handleClick={() => {
                if (!isUnderReview) {
                  handleStart(record?._id, record?.raisedBy?.userName, "");
                  setSelected(record?._id);
                }
              }}
              disabled={isUnderReview}
            />
            <button
              className="viewBtn"
              onClick={() => {
                setSelected(record?._id);
                setViewDocuments(true);
              }}
            >
              View Documents
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="creation_request">
      <div className="table_content_wrapper">
        <Table
          columns={columns}
          dataSource={pendingRequests}
          scroll={{
            // x: 2100,
            y: `calc(70vh - 30px)`,
          }}
          className="main_table"
          pagination={false}
        />
      </div>
      <div className="pagination_wrapper">
        <Pagination
          total={totalCount}
          showTotal={false}
          defaultPageSize={10}
          current={pageNum}
          pageSize={pageSize}
          onChange={onPageChange}
        />
      </div>
      {viewDocuments && getDocumentsModal()}
    </div>
  );
};

export default CreationRequest;
